import React, { FC } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { createStore, StateMachineProvider } from 'little-state-machine'
import { RootRoutes } from './RootRoutes'
import { AppStateProvider } from './components/Context'

createStore(
  {},
  {
    name: 'sparling_financial_web',
  },
)

export const App: FC = () => {
  return (
    <StateMachineProvider>
      <BrowserRouter>
        <ToastContainer />
        <AppStateProvider>
          <RootRoutes />
        </AppStateProvider>
      </BrowserRouter>
    </StateMachineProvider>
  )
}
